import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

export const Layout = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        const titles = {
            '/': 'Shiva Security Services | Professional Security Solutions in Bangalore',
            '/about': 'About Us | Shiva Security Services',
            '/services': 'Services | Shiva Security Services',
            '/training': 'Training | Shiva Security Services',
            '/gallery': 'Gallery | Shiva Security Services',
            '/clients': 'Clients | Shiva Security Services',
            '/careers': 'Careers | Shiva Security Services',
            '/contact': 'Contact | Shiva Security Services',
        };
        document.title = titles[location.pathname] || 'Shiva Security Services';
    }, [location.pathname]);

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace('#', '');
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                return;
            }
        }
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, [location.pathname, location.hash]);

    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1">
                {children}
            </main>
            <Footer />
        </div>
    );
};
